/* Live product prices for blog article cards.
   Reads the real price from Shopify at view time and overwrites the value baked
   into the article HTML. If anything fails, the baked value is left untouched. */
(function () {
  'use strict';

  var nodes = document.querySelectorAll('[data-ds-price]');
  if (!nodes.length) return;

  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AED';

  function cacheGet(handle) {
    try {
      var raw = sessionStorage.getItem('dsp:' + handle);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function cacheSet(handle, data) {
    try { sessionStorage.setItem('dsp:' + handle, JSON.stringify(data)); } catch (e) {}
  }

  /* Match whatever decimal style the card already used: "AED 99" stays "AED 99",
     "AED 99.00" stays "AED 99.00". */
  function hasDecimals(text) { return /[.,]\d{2}(\D|$)/.test(text || ''); }

  function money(cents, decimals) {
    var n = cents / 100;
    return CURRENCY + ' ' + (decimals ? n.toFixed(2) : String(Math.round(n)));
  }

  function pickVariant(data, variantId) {
    if (!variantId || !data.variants) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === String(variantId)) return data.variants[i];
    }
    return null;
  }

  function apply(node, data) {
    var decimals = hasDecimals(node.textContent);
    var variant  = pickVariant(data, node.getAttribute('data-ds-variant'));

    var price     = variant ? variant.price : data.price_min;
    var compareAt = variant ? variant.compare_at_price : data.compare_at_price_min;
    var available = variant ? variant.available : data.available;

    if (node.getAttribute('data-ds-role') === 'compare') {
      /* Strike-through price. Hide it entirely when the product is no longer on sale,
         so the card never shows a fake discount. */
      if (compareAt && compareAt > price) {
        node.textContent = money(compareAt, decimals);
        node.hidden = false;
      } else {
        node.hidden = true;
      }
      return;
    }

    node.textContent = money(price, decimals);
    if (available) node.removeAttribute('data-ds-soldout');
    else node.setAttribute('data-ds-soldout', '');
  }

  /* One request per unique product, not per card. */
  var groups = {};
  Array.prototype.forEach.call(nodes, function (node) {
    var handle = node.getAttribute('data-ds-price');
    if (!handle) return;
    (groups[handle] = groups[handle] || []).push(node);
  });

  Object.keys(groups).forEach(function (handle) {
    var targets = groups[handle];

    var cached = cacheGet(handle);
    if (cached) {
      targets.forEach(function (node) { apply(node, cached); });
      return;
    }

    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
      .then(function (p) {
        var data = {
          price_min: p.price_min,
          compare_at_price_min: p.compare_at_price_min,
          available: p.available,
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, price: v.price, compare_at_price: v.compare_at_price, available: v.available };
          })
        };
        cacheSet(handle, data);
        targets.forEach(function (node) { apply(node, data); });
      })
      .catch(function () { /* leave the baked price exactly as it is */ });
  });
})();
